<template>
  <div class="terminal-order-index">
    <basic-container>
      <TerminalOrderSearch
        ref="searchWrapper"
        :channel-options="channelOptions"
        :tenant-options="tenantOptions"
        @search="handleSearch"
        @export="handleExport"
      />
      
      <div class="table-container">
        <TerminalOrderTable
          :table-data="tableData"
          :loading="loading"
          @refund="openRefundDialog"
        />
      </div>

      <div class="pagination-container">
        <ElementPagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

      <TerminalRefundDialog
        :visible.sync="refundVisible"
        :refund-detail="currentRefund"
        @success="getList"
      />
    </basic-container>
  </div>
</template>

<script>
import TerminalOrderSearch from './components/search'
import TerminalOrderTable from './components/table'
import TerminalRefundDialog from './components/RefundDialog'
import ElementPagination from '@/components/ElementPagination'
import { 
  getOrderList, 
  getChannelOptions, 
  exportOrderList,
  getTenantOptions
} from '@/api/memberNew/terminal'
import moment from 'moment'

export default {
  name: 'TerminalOrderIndex',
  components: {
    TerminalOrderSearch,
    TerminalOrderTable,
    TerminalRefundDialog,
    ElementPagination
  },
  data() {
    return {
      channelOptions: [],
      tenantOptions: [],
      tableData: [],
      loading: false,
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      searchParams: {},
      refundVisible: false,
      currentRefund: {}
    }
  },
  created() {
    this.fetchChannelOptions()
    this.fetchTenantOptions()
    this.getList()
  },
  activated() {
    if (this.$route.query.outTradeNo) {
      this.$refs.searchWrapper.setKeyword(this.$route.query.outTradeNo)
    }
  },
  methods: {
    fetchChannelOptions() {
      getChannelOptions('order').then(res => {
        if (res.data.data) {
          this.channelOptions = res.data.data
        }
      })
    },
    fetchTenantOptions() {
      getTenantOptions().then(res => {
        if (res.data.data) {
           this.tenantOptions = res.data.data
        }
      })
    },
    getList() {
      this.loading = true
      
      const params = {
        ...this.searchParams,
        page: this.page.currentPage,
        limit: this.page.pageSize
      }
      
      getOrderList(params).then(res => {
        const data = res.data
        if (data && data.code === 200) {
           const list = data.data.records || []
           this.tableData = list.map(item => {
             return {
               ...item,
               goodsPrice: (item.goodsPrice / 100).toFixed(2),
               totalPayFee: (item.totalPayFee / 100).toFixed(2),
               appName: `(${item.appId})${item.appName}`,
               buyTypeName: item.buyType === 1 ? '首购' : (item.buyType === 2 ? '续购' : item.buyType),
               payTypeName: this.formatPayType(item.payType),
               statusName: this.formatStatus(item.status)
             }
           })
           this.page.total = data.data.total
        } else {
           this.$message.error(data.msg || '获取列表失败')
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      }).finally(() => {
        this.loading = false
      })
    },
    formatStatus(status) {
       const map = {
         0: '未支付',
         1: '已支付',
         2: '支付失败',
         3: '记账'
       }
       return map[status] || status
    },
    formatPayType(type) {
        return type
    },
    handleSearch(params) {
      this.searchParams = params
      this.page.currentPage = 1
      this.getList()
    },
    async handleExport(params) {
      try {
        await this.$confirm('确认导出当前数据吗？', '提示', {
          type: 'warning'
        })
        
        // 使用 exportOrderList API
        const res = await exportOrderList(params)
        const data = res.data
        
        if (data) {
          const blob = new Blob([data])
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '订单数据_' + moment().format('YYYYMMDD') + '.xlsx'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        }
      } catch (err) {
        if (err !== 'cancel') {
           console.error(err)
           this.$message.error('导出失败')
        }
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
    openRefundDialog(row) {
      this.currentRefund = row
      this.refundVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.terminal-order-index {
  .table-container {
    margin-top: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    padding: 16px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
